// extracted by mini-css-extract-plugin
export var form = "signin-module--form--5d3e8";
export var formContainer = "signin-module--formContainer--4c48a";
export var formDescription = "signin-module--formDescription--80174";
export var newUser = "signin-module--newUser--4d3ed";
export var userLink = "signin-module--userLink--99ce0";